import {Injectable, Injector} from "@angular/core";
import r2Core from '@core/r2';
import {environment} from "@env";
import {IChatSetting} from "@listat/r2-core";
import {ChatSettingBase, IQuickAction, ISkill} from "@core/base/chat-setting-base";
import {BehaviorSubject, Observable, of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class WebChatSetting extends ChatSettingBase implements ChatSettingBase {
    private core = r2Core.chat;
    private $setting = new BehaviorSubject<IChatSetting>({});

    public $settingUpdate: BehaviorSubject<IChatSetting> = new BehaviorSubject<IChatSetting>({});

    private quickActions: IQuickAction[] = [...environment.quick_actions.default];
    private skills: BehaviorSubject<ISkill[]> = new BehaviorSubject<ISkill[]>([]);
    private observerSetting = {
        update: (setting: IChatSetting) => {
            this.$setting.next(setting);
        }
    }

    constructor() {
        super();
        this.init()
    }

    public async init(): Promise<void> {
        this.observerSetting = this.core.subscribeOnUpdateSetting(this.observerSetting);
    }

    public getSetting(): IChatSetting {
        return this.$setting.getValue();
    }

    public $getSetting(): Observable<IChatSetting> {
        return this.$setting.asObservable();
    }

    public setSetting(newSetting: IChatSetting): IChatSetting {
        this.$settingUpdate.next(newSetting);
        return newSetting;
    }

    public getSettingOriginal<T>(): T {
        throw new Error('Method not implemented');
    }

    public getQuickActionsDefault(): IQuickAction[] {
        return this.quickActions;
    }

    public $getQuickActions(): Observable<IQuickAction[]> {
        return of(this.quickActions);
    }

    public setQuickActions(newActions: IQuickAction[]): IQuickAction[] {
        return this.quickActions = newActions;
    }

    public $getSkills(): Observable<ISkill[]> {
        return this.skills.asObservable();
    }

    public setSkills(newSkills: ISkill[]): ISkill[] {
        this.skills.next(newSkills);
        return newSkills;
    }

    public override onDestroy(): void {
        this.core.unSubscribeOnUpdateSetting(this.observerSetting);
    }
}
